<template>
	<AppDialog hideCloseButton disableMaxWidth :dialogName="'CommandBarShortcut'" width="80vw" max-width="80vw">
		<div class="dialog-content width-100 flex-column flex-centerize">
			<div v-if="isLoading" class="width-100 height-100 flex-centerize">
				<AppLoader size="18px" />
			</div>
			<div v-show="!isLoading" class="width-100" style="position: relative; padding-bottom: 56.25%; height: 0">
				<iframe
					class="frame"
					frameborder="0"
					allowfullscreen
					:src="iframeUrl"
					mozallowfullscreen
					webkitallowfullscreen
					@load="isLoading = false"
					style="top: 0; left: 0; width: 100%; height: 100%; position: absolute"
				/>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'IFrameDialog',
	components: {
		AppDialog,
	},
	props: {
		iframeUrl: { type: String },
		dialogPromiseHandlers: { type: Object },
	},
	computed: {},
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
	},
	data() {
		return {
			isLoading: true,
		};
	},
};
</script>

<style scoped lang="scss">
.dialog-content {
	width: 80vw;
	height: 80vh;
	border-radius: 10px;
	background: var(--white);
	box-shadow: 0px 3px 6px #00000029;
}

.frame {
	border-radius: 10px;
}
</style>
